
interface HTMLContentProps {
    htmlContent: string;
}

export const HTMLContent: React.FC<HTMLContentProps> = ({ htmlContent }) => {
    return (
        <div className="prose"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
    );
};
